import Vue from 'vue'

import { debounce } from 'lodash'

import { Colors, UTMParams, UTMSources, buildUTMLink, buildUTMQuery, fetchShortLink, isUTMUrlValid, normalizeUTMUrl, utmParamsBySource } from '@sigma-frontend-libs/commons'

import render from './render'

export default {
  name: 'UTM',

  data() {
    const showReference = {}
    for (const key in UTMParams) {
      showReference[key] = false
    }
    const params = {}
    for (const key in utmParamsBySource[UTMSources.custom]) {
      params[key] = utmParamsBySource[UTMSources.custom][key]
    }

    return {
      showReference,

      protocol: undefined,
      url: undefined,
      shortLink: undefined,

      source: UTMSources.custom,
      params,

      showDialog: false,
      loading: false
    }
  },

  watch: {
    url(value) {
      if (value) {
        this.url = value.replace(/https?:\/\//, '')
      }
    },

    source(value) {
      this.setDefaultsBySource(value)
    },

    fullLink(value) {
      if (value) {
        this.getShortLink()
      } else {
        this.shortLink = undefined
      }
    }
  },

  computed: {
    utmParams() {
      if (this.urlIsValid) {
        return buildUTMQuery(this.params)
      }

      return ''
    },

    cleanUrl() {
      return normalizeUTMUrl(this.url)
    },
    urlIsValid() {
      return isUTMUrlValid(this.cleanUrl)
    },

    fullLink() {
      if (this.protocol && this.cleanUrl && this.urlIsValid) {
        return buildUTMLink(this.protocol, this.cleanUrl, this.utmParams)
      }

      return ''
    }
  },

  methods: {
    getShortLink: debounce(
      async function() {
        if (this.fullLink && this.urlIsValid) {
          this.loading = true
          try {
            const shortLinkValue = await fetchShortLink(this.fullLink)
            if (shortLinkValue !== undefined) {
              this.shortLink = shortLinkValue
            }
          } catch {
            this.addSnackbar({
              text: this.getTranslate('utm.snackbars.error'),
              type: Colors.error
            })
          } finally {
            this.loading = false
          }
        }
      },
      500,
      {
        leading: false,
        trailing: true
      }
    ),

    setDefaultsBySource(source) {
      source = source || this.source
      for (const key in this.params) {
        Vue.set(this.params, key, utmParamsBySource[source][key])
      }
    }
  },

  render
}
